import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { SessionService } from '../services/session.service';

const AUTH_EXEMPT_PATHS = [
  '/api/users/login',
  '/api/users/register',
  '/api/users/send-password-reset-code',
  '/api/users/validate-password-reset-code',
  '/api/users/reset-password',
];

export const UnauthorizedErrorInterceptorInterceptor: HttpInterceptorFn = (req, next) => {
  const session = inject(SessionService);
  return next(req).pipe(
    catchError(response => {
      const isAuthExempt = AUTH_EXEMPT_PATHS.some((path) => req.url.includes(path));
      if (
        !isAuthExempt &&
        'HttpErrorResponse' == response?.name &&
        response?.status === 401
      ) {
        console.log(response?.statusText + " Server Response Intercepted");
        session.onExpiredSession();
      }
      return throwError(() => response);
    })
  );
};
